import React from "react";
import { Spin, message } from "antd";
import { Auth, API } from "aws-amplify";
import { getQueryParameters } from "../../utils/query";
import BaseAlphaUI from "../../BaseAlphaUI";

class OAuthProvider extends React.Component {
  async componentDidMount(): Promise<void> {
    this.oauth();
  }

  oauth = async (): Promise<void> => {
    const session = await Auth.currentSession();
    const params = getQueryParameters();
    try {
      const apiName = BaseAlphaUI.getAuthApiName();
      const url = BaseAlphaUI.getOauthUrl();
      if (!apiName || !url) {
        throw new Error(
          "Base alpha UI is missing configuration: Oauth url"
        );
      }
      const response = await API.post(apiName, url, {
        body: {
          token: session.getAccessToken().getJwtToken(),
          ...params,
        },
      });
      if (response.url) {
        window.location.href = response.url;
      } else if (response.message) {
        message.error(response.message);
      }
    } catch (e) {
      message.error(e.error || "an error occurred");
    }
  };

  render(): React.ReactElement {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          flex: 1,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Spin />
      </div>
    );
  }
}

export default OAuthProvider;
